<template>
<a href="/chengshihui/index.html" :class="current" :data-scp="scp" @click="changePage($event)">
	<i class="icon icon-citihui"></i><span>城市惠</span>
</a>
</template>

<script>
export default {
	props: ['scp', 'current']
	, methods: {
		changePage: function(e){
			if( e.currentTarget.href === location.origin + location.pathname ){
				e.preventDefault();
				e.stopPropagation();
			}
		}
	}
};
</script>